<template>
  <div class="text-center employees-upload-success">
    <v-icon style="margin-bottom: 56px">$employeeUploadSuccess</v-icon>

    <h1 class="mb-4">We're Processing Your Data!</h1>
    <p class="mb-8 desc">
      Your data is in good hands! We’re processing the employee data. Feel free
      to explore the rest of the app. We’ll send you an
      <b>email notification</b> once everything’s ready.
    </p>

    <yellow-button :to="{ name: 'dashboard' }">
      View Your Dashboard
    </yellow-button>
  </div>
</template>

<script>
import YellowButton from "@/components/providertrust/buttons/YellowButton";

export default {
  name: "EmployeesUploadSuccess",
  components: {
    YellowButton
  }
};
</script>

<style lang="sass" scoped>
h1
  font-size: 36px
  font-weight: 600
.desc
  color: $color-pt-black
.employees-upload-success
  padding: 32px 156px 104px 156px
</style>
